import { useState, useContext } from 'react'

import { Backdrop, CircularProgress, Typography, Box } from '@mui/material'

import { AppContext } from '/providers/app-context'
import Header from './header'
import Settings from '/components/settings'
import config from '/providers/config'
import PopupShell from './editor/popup-shell'
import StudioSidebar from './studio-sidebar'

const PageWrapper = ({ children, title, HelpText = EmptyHelp, heading: _heading, menu, isErrorPage = false, hideSidebar = false, hideSettings = false, selectedTemplate, scrollContent = false }) => {

  const { client, processing, copyingEmail } = useContext(AppContext)
  const [showHelp, setShowHelp] = useState(false)
  const [showSettings, setShowSettings] = useState(false)

  const toggleHelp = () => setShowHelp(!showHelp)
  const toggleSettings = () => setShowSettings(!showSettings)

  return (
    <div style={{ minWidth: "1024px", overflowX: "auto" }}>
      {!copyingEmail &&
        <Box sx={{color:"menubar.fg"}}>
          <Header title={title} toggleHelp={toggleHelp} toggleSettings={toggleSettings} hideSettings={hideSettings} isErrorPage={isErrorPage} />

          <PopupShell open={showHelp} onClose={toggleHelp} width={config.helpDrawerWidth} variant="solid">
            <div style={{ marginTop: 24, overflow: "auto", height: "100%" }}>
              <div className='help-content'>
                <HelpText />
                <div className='p-5 pt-0'>
                  <a href='https://docs.smartix.uk/getting-started-with-smartix-studio.pdf' target='_blank' rel='noreferrer' className='link'>Getting started with Studio</a>
                </div>
              </div>
            </div>
          </PopupShell>

          <PopupShell open={showSettings} onClose={toggleSettings} width={config.settingsDrawerWidth} variant="solid">
            <div style={{ marginTop: 24, overflow: "auto", height: "100%" }}>
              <Settings />
            </div>
          </PopupShell>

        </Box>
      }

      <Box sx={{ position: "fixed", top: client?.initialised ? (copyingEmail ? 0 : 64) : 64, bottom: 0, left: 0, right: 0, width: "max(1024px, 100vw)", overflowX: "hidden", zIndex: 101, display: 'flex' }}>
        {client?.initialised && !copyingEmail && !hideSidebar && <StudioSidebar sectionMenu={menu} selectedTemplate={selectedTemplate} />}
        <Box sx={{ height: "100%", flex: 1, minWidth: 0, overflowY: scrollContent ? "auto" : "visible" }}>
          {children}
        </Box>
      </Box>

      {processing &&
        <div className="flex h-screen">
          <div className="m-auto flex flex-row gap-10">
            <Backdrop open={true} sx={{ color: '#fff', zIndex: 99999 }}>
              <CircularProgress className='mr-20' /> Processing...
            </Backdrop>
          </div>
        </div>
      }
    </div>
  )
}

export default PageWrapper

// Default prevents errors if HelpText is undefined
// This occures for the loading screen
// Also seems to happen for other pages during early render. Not sure why?
const EmptyHelp = () => {
  return (
    <Typography variant='h5'>Help</Typography>
  )
}
